import { Spinner as ChakraSpinner } from "@chakra-ui/react";
import { SpinnerProps } from "@chakra-ui/spinner/dist/types/spinner";

interface IProps extends SpinnerProps {}

const Spinner = ({ ...props }: IProps) => {
  return <ChakraSpinner size="xl" {...props} />;
};

export { Spinner };
